module.exports = __webpack_public_path__ + "static/media/home_page_card_section.b4c9acb0.png";